module.exports = __webpack_public_path__ + "static/media/district53.cf5c0b1a.pdf";